import { render, staticRenderFns } from "./ObjectBar.vue?vue&type=template&id=51d3109a&scoped=true&"
import script from "./ObjectBar.vue?vue&type=script&lang=js&"
export * from "./ObjectBar.vue?vue&type=script&lang=js&"
import style0 from "./ObjectBar.vue?vue&type=style&index=0&id=51d3109a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d3109a",
  null
  
)

export default component.exports